import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosambhajinagar() {



  const cardData = {
"keyword": "Pune to Sambhaji Nagar Cab (Aurangabad)",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Sambhaji Nagar Cab (Aurangabad) service for travelers seeking safe, affordable, and convenient intercity transportation. Whether you are traveling for tourism, business meetings, family visits, religious trips, or heritage exploration, our taxi service ensures a smooth and stress-free journey. With experienced drivers, clean air-conditioned vehicles, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Sambhaji Nagar (Aurangabad). Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and corporate clients. With flexible one-way and round-trip options, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures comfortable and timely travel between Pune and Sambhaji Nagar.",

"topPlaces": [
  {
    "title": "Ajanta Caves",
    "description":
      "Ajanta Caves are a UNESCO World Heritage Site famous for ancient Buddhist rock-cut caves and paintings. Travelers using Pune to Sambhaji Nagar cab service often visit this historic destination for cultural and heritage tourism."
  },
  {
    "title": "Ellora Caves",
    "description":
      "Ellora Caves are renowned for magnificent rock-cut temples representing Buddhist, Hindu, and Jain architecture. Cab travelers from Pune enjoy exploring this world-famous archaeological site."
  },
  {
    "title": "Bibi Ka Maqbara",
    "description":
      "Bibi Ka Maqbara is a beautiful Mughal-era monument often called the mini Taj Mahal of Maharashtra. Pune to Aurangabad taxi service provides convenient access for sightseeing and photography."
  },
  {
    "title": "Daulatabad Fort",
    "description":
      "Daulatabad Fort is a historic hill fort known for strong defense architecture and panoramic views. Travelers booking Pune to Sambhaji Nagar cabs often include this fort in their itinerary."
  },
  {
    "title": "Grishneshwar Temple",
    "description":
      "Grishneshwar Temple is one of the twelve Jyotirlingas dedicated to Lord Shiva and a major pilgrimage destination near Aurangabad. Taxi from Pune ensures comfortable travel for devotees."
  },
  {
    "title": "Panchakki",
    "description":
      "Panchakki is a historic water mill showcasing ancient engineering and Mughal architecture. Pune to Sambhaji Nagar cab booking is ideal for history and architecture enthusiasts."
  },
  {
    "title": "Siddharth Garden and Zoo",
    "description":
      "Siddharth Garden and Zoo is a family-friendly attraction in Aurangabad featuring greenery, animals, and recreational spaces. Travelers from Pune often visit this destination for leisure outings."
  },
  {
    "title": "Aurangabad Caves",
    "description":
      "Aurangabad Caves are ancient Buddhist caves known for intricate carvings and historical significance. Pune to Aurangabad cab service offers easy access for tourists and heritage explorers."
  },
  {
    "title": "Salim Ali Lake",
    "description":
      "Salim Ali Lake is a peaceful nature spot in Aurangabad popular for bird watching and scenic surroundings. Cab travelers from Pune enjoy relaxing visits to this attraction."
  },
  {
    "title": "Prozone Mall",
    "description":
      "Prozone Mall is one of the largest shopping and entertainment destinations in Aurangabad featuring retail stores, dining, and cinemas. Pune to Sambhaji Nagar taxi service makes it convenient for shopping and leisure activities."
  }
],



services: [
  {
    name: "Pune to Aurangabad Cab",
    description: "Pune to Aurangabad cab service provides reliable transportation between Pune and Aurangabad with comfortable vehicles and experienced drivers. Vehicles are suitable for highway travel ensuring smooth and safe journeys for families, tourists, and business travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Aurangabad. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Pune to Sambhaji Nagar Taxi",
    description: "Pune to Sambhaji Nagar taxi service offers dependable transportation for passengers traveling between Pune and Sambhaji Nagar with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for business trips, tourism, and family journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Sambhaji Nagar. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Cab from Pune to Aurangabad",
    description: "Cab from Pune to Aurangabad service provides comfortable intercity transportation for passengers traveling for business, tourism, and family visits. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune and Aurangabad. Ideal for one-way and round-trip travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Aurangabad",
    description: "Taxi from Pune to Aurangabad service offers reliable transportation with comfortable vehicles and professional drivers for long-distance travel between Pune and Aurangabad. Vehicles provide smooth highway travel suitable for tourism, business meetings, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Aurangabad. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Aurangabad Cab Service",
    description: "Pune to Aurangabad cab service provides dependable transportation solutions for passengers traveling between Pune and Aurangabad with comfortable vehicles and experienced chauffeurs. Vehicles are suitable for highway travel ensuring safe and smooth journeys for individuals, families, and corporate travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Aurangabad. Ideal for business travel, tourism, and family trips. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Pune to Aurangabad Taxi Fare",
    description: "Pune to Aurangabad taxi fare service provides transparent pricing information for passengers planning intercity travel between Pune and Aurangabad. Travelers can estimate transportation costs based on vehicle type, travel distance, and trip requirements. Comfortable vehicles ensure smooth highway travel with professional drivers offering safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Aurangabad. Flexible booking options allow convenient fare estimation and taxi reservations."
  },
  {
    name: "Pune to Aurangabad One Way Cab",
    description: "Pune to Aurangabad one way cab service provides economical transportation for passengers traveling from Pune to Aurangabad without return travel requirements. Comfortable vehicles ensure smooth highway travel suitable for business trips, tourism, and family visits. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune and Aurangabad including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Aurangabad Round Trip Taxi",
    description: "Pune to Aurangabad round trip taxi service offers convenient return transportation for passengers planning travel between Pune and Aurangabad. Comfortable vehicles provide smooth highway journeys with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Aurangabad. Ideal for business travel, tourism, and family trips. Flexible booking options allow convenient round-trip taxi reservations."
  },
  {
    name: "Pune to Aurangabad Cab Booking",
    description: "Pune to Aurangabad cab booking service allows passengers to reserve comfortable intercity transportation between Pune and Aurangabad. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Aurangabad. Flexible booking options allow instant and advance cab reservations."
  },
  {
    name: "Cheap Pune to Aurangabad Cab",
    description: "Cheap Pune to Aurangabad cab service provides affordable transportation between Pune and Aurangabad with comfortable vehicles and economical pricing. Vehicles ensure reliable highway travel suitable for tourism, business travel, and family journeys. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Aurangabad. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Aurangabad Taxi",
    description: "Best Pune to Aurangabad taxi service offers premium transportation with comfortable vehicles and professional chauffeurs for smooth intercity travel. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for business travel, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Aurangabad. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Aurangabad Cab",
    description: "Sedan Pune to Aurangabad cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Aurangabad. Sedan vehicles provide smooth highway travel with comfortable seating and luggage space suitable for intercity journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Aurangabad. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Aurangabad Taxi",
    description: "SUV Pune to Aurangabad taxi service provides spacious transportation for families and groups traveling between Pune and Aurangabad. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for long-distance journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Aurangabad. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Aurangabad Cab",
    description: "Innova Pune to Aurangabad cab service provides premium SUV transportation for passengers seeking comfortable and reliable intercity travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for business travel, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Aurangabad. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Highway Cab Pune Aurangabad",
    description: "Highway cab Pune Aurangabad service offers dependable long-distance transportation between Pune and Aurangabad with comfortable vehicles and experienced chauffeurs. Vehicles ensure smooth highway travel suitable for business trips, tourism, and family travel requirements. Professional drivers ensure safe driving and reliable transportation services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Aurangabad. Flexible booking options allow convenient highway cab reservations."
  },
  {
    name: "Pune to Sambhajinagar Cab Service",
    description: "Pune to Sambhajinagar cab service provides reliable transportation between Pune and Sambhajinagar with comfortable vehicles and professional chauffeurs. Vehicles ensure smooth highway travel suitable for business journeys, tourism, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Sambhajinagar. Flexible booking options allow convenient one-way and round-trip cab reservations."
  }
],

tableData: [
  ["Pune to Aurangabad Cab", "Pune to Sambhaji Nagar Taxi"],
  ["Cab from Pune to Aurangabad", "Taxi from Pune to Aurangabad"],
  ["Pune to Aurangabad Cab Service", "Pune to Aurangabad Taxi Fare"],
  ["Pune to Aurangabad One Way Cab", "Pune to Aurangabad Round Trip Taxi"],
  ["Pune to Aurangabad Cab Booking", "Cheap Pune to Aurangabad Cab"],
  ["Best Pune to Aurangabad Taxi", "Sedan Pune to Aurangabad Cab"],
  ["SUV Pune to Aurangabad Taxi", "Innova Pune to Aurangabad Cab"],
  ["Highway Cab Pune Aurangabad", "Pune to Sambhajinagar Cab Service"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Sambhaji Nagar Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Sambhaji Nagar cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe long-distance travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Aurangabad Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Sambhaji Nagar (Aurangabad) cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Sambhaji Nagar Cab Availability",
        WhyChoosedescription: "Our Pune to Sambhaji Nagar cab service operates 24 hours a day for family trips, business travel, temple visits, tourism, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance travel experiences for passengers."
      },
      {
        WhyChooseheading: "One Way & Round Trip Cab Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Sambhaji Nagar taxi service, round-trip bookings, Ajanta Ellora tours, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, business travelers, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Highway Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Sambhaji Nagar highway routes and ensure safe driving, smooth travel, and timely arrival for every journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Sambhaji Nagar cab service?", answer: "Pune to Sambhaji Nagar cab service provides comfortable taxi transportation between Pune and Sambhaji Nagar (Aurangabad) for tourism, business travel, and family trips." },
    { question: "Is Pune to Sambhaji Nagar cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Sambhaji Nagar cab service." },
    { question: "Which vehicles are available for Pune to Sambhaji Nagar travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Sambhaji Nagar?", answer: "Yes, customers can book one-way as well as round-trip Pune to Sambhaji Nagar taxi services." },
    { question: "Do you provide Ajanta Ellora tour cab services?", answer: "Yes, Shivai Travels provides taxi services for Ajanta Caves, Ellora Caves, and local sightseeing tours." },
    { question: "Are all Pune to Sambhaji Nagar taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel." },
    { question: "Can I book Pune to Sambhaji Nagar cab service online?", answer: "Yes, customers can easily book Pune to Sambhaji Nagar cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group travel." },
    { question: "Are Pune to Sambhaji Nagar cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Sambhaji Nagar cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak tourist seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Vinay Patil",
      feedback:
        "Booked Pune to Sambhaji Nagar cab service with Shivai Travels. Comfortable vehicle, professional driver, and smooth highway journey.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Neha Kulshrestha",
      feedback:
        "Excellent Pune to Aurangabad taxi service. Affordable pricing, clean cab, and very reliable travel experience.",
      rating: 5
    }
  ];

































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Sambhaji Nagar (Aurangabad) Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-aurangabad-cab.jpg",
  "description": "Book Pune to Sambhaji Nagar (Aurangabad) cab service for safe and comfortable outstation travel. Shivai Travels offers affordable one-way and round-trip taxi booking with sedan, SUV, Innova, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹11/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-sambhaji-nagar-cab"
  }
};






  return (
    <div>

<Helmet>
  <title>Pune to Sambhaji Nagar Cab Service | Aurangabad Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Sambhaji Nagar (Aurangabad) cab service for one-way and round trip travel. Affordable taxi options including sedan, SUV, Innova, and luxury cabs available 24x7 for safe intercity journeys."
  />

  <meta
    name="keywords"
    content="pune to aurangabad cab, pune to sambhaji nagar taxi, cab from pune to aurangabad, taxi from pune to aurangabad, pune to aurangabad cab service, pune to aurangabad taxi fare, pune to aurangabad one way cab, pune to aurangabad round trip taxi, pune to aurangabad cab booking, cheap pune to aurangabad cab, best pune to aurangabad taxi, sedan pune to aurangabad cab, suv pune to aurangabad taxi, innova pune to aurangabad cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/27.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetosambhajinagar;